export class PasskeySupportError extends Error {
  constructor(code, message) {
    super(message);
    this.name = 'PasskeySupportError';
    this.code = code;
  }
}

export async function assertPasskeySupport() {
  if (!window.isSecureContext) {
    throw new PasskeySupportError(
      'HTTPS_REQUIRED',
      'Passkey работает только по HTTPS. Для локального POC откройте именно http://localhost:4173.',
    );
  }

  if (!window.PublicKeyCredential || !navigator.credentials) {
    throw new PasskeySupportError(
      'WEBAUTHN_UNSUPPORTED',
      'Этот браузер не поддерживает WebAuthn. Откройте страницу в актуальном Safari, Chrome или Edge.',
    );
  }

  if (typeof PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable === 'function') {
    const available =
      await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
    if (!available) {
      throw new PasskeySupportError(
        'PLATFORM_AUTHENTICATOR_UNAVAILABLE',
        'На устройстве недоступно системное подтверждение. Настройте Touch ID, Face ID, Windows Hello или код блокировки.',
      );
    }
  }
}

export async function runPasskeyCeremony(prepared) {
  if (prepared.ceremony === 'registration') {
    const { startRegistration } = await import('@simplewebauthn/browser');
    return startRegistration({ optionsJSON: prepared.options });
  }

  const { startAuthentication } = await import('@simplewebauthn/browser');
  return startAuthentication({ optionsJSON: prepared.options });
}

export function describePasskeyError(error) {
  if (error instanceof PasskeySupportError) {
    return { code: error.code, message: error.message };
  }

  if (error?.name === 'NotAllowedError') {
    return {
      code: 'USER_CANCELLED',
      message: 'Подтверждение отменено или время ожидания истекло. Подписка не подключена.',
    };
  }

  if (error?.name === 'InvalidStateError') {
    return {
      code: 'PASSKEY_ALREADY_EXISTS',
      message:
        'Для этой демо-установки passkey уже существует на устройстве, но сервер его не видит. Удалите старый ключ BOLT PROTECT в менеджере паролей или очистите локальные данные POC.',
    };
  }

  if (error?.name === 'SecurityError') {
    return {
      code: 'ORIGIN_MISMATCH',
      message: 'Домен страницы не совпал с RP ID. Проверьте EXPECTED_ORIGIN и RP_ID на сервере.',
    };
  }

  return {
    code: error?.code ?? 'UNKNOWN_ERROR',
    message: error?.message ?? 'Не удалось выполнить подтверждение. Подписка не подключена.',
  };
}

export function waitForPaint() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });
}
